import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSuccessBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7850_501804)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M78.043 48.043C78.4335 47.6524 79.0665 47.6524 79.457 48.043C79.8476 48.4335 79.8476 49.0665 79.457 49.457L53.207 75.707C52.8165 76.0976 52.1835 76.0976 51.793 75.707L40.543 64.457L40.4746 64.3809C40.1543 63.9881 40.1768 63.4091 40.543 63.043C40.9091 62.6769 41.4881 62.6543 41.8809 62.9746L41.957 63.043L52.5 73.5859L78.043 48.043Z",
			fill: "url(#paint0_linear_7850_501804)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M104 60C104 35.6995 84.3005 16 60 16C35.6995 16 16 35.6995 16 60C16 84.3005 35.6995 104 60 104C84.3005 104 104 84.3005 104 60ZM106 60C106 85.4051 85.4051 106 60 106C34.5949 106 14 85.4051 14 60C14 34.5949 34.5949 14 60 14C85.4051 14 106 34.5949 106 60Z",
			fill: "#14151F"
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_7850_501804",
		x1: 40.2502,
		y1: 75.9999,
		x2: 84.2345,
		y2: 60.3713,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#E45D96"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7850_501804",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 120,
			height: 120,
			fill: "white"
		})
	})] })]
});
export default SvgSuccessBig;
